module.exports = __webpack_public_path__ + "static/media/Stella-barnhalsa-logo.e69a0def.webp";